/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import { getStorageItem } from '@utils/storage';
import { ReactNode } from 'react';
import NotFoundPage from '@pages/not-found';
import { hasMinimumUserRole } from '@models/user/user';

export function Protected({ minRole, children }: { minRole: number; children: ReactNode }) {
    let state = false;
    try {
        const data = getStorageItem('user-info'),
            json = JSON.parse(data ?? '{}');
        if (hasMinimumUserRole(Number(json.role), minRole)) {
            state = true;
        }
    } catch {
        return NotFoundPage();
    }

    return state ? children : NotFoundPage();
}
